import { RepositoryFactory } from 'repository/RepositoryFactory';

let DashboardRepository = RepositoryFactory.get('dashboard');

//----------------------------------------------
// Action that makes the API call to retrieve
// the average times for order, kitchen, item, and session
// params: { scale, year, weekdays, timeRange }
export const getTimingStatistics = (params = {}) => async (dispatch) => {
  try {
    let { data } = await DashboardRepository.getTimingStatistics(params);

    if (data) {
      dispatch({
        type: 'TIMING_STATISTICS',
        payload: data
      });
    }
  } catch (err) {
    console.log('error', err.message);
  }
};

//----------------------------------------------
// Action that makes the API call to retrieve
// the average statistics
export const getSessionsStatistics = (params = {}) => async (dispatch) => {

  try {
    let { data } = await DashboardRepository.getSessionsStatistics(params);

    if (data) {
      dispatch({
        type: 'SESSIONS_STATISTICS',
        payload: data
      });
    }
  } catch (err) {
    console.log('error', err.message);
  }
};

//----------------------------------------------
// Action that makes the API call to retrieve
// product and category statistics
export const getCategoriesStatistics = (params = {}) => async (dispatch) => {

  try {
    let { data } = await DashboardRepository.getCategoriesStatistics(params);

    if (data) {
      dispatch({
        type: 'CATEGORIES_STATISTICS',
        payload: data
      });
    }
  } catch (err) {
    console.log('error', err.message);
  }
};

//----------------------------------------------
// Action that makes the API call to retrieve
// courses statistics
export const getCoursesStatistics = (params = {}) => async (dispatch) => {

  try {
    let { data } = await DashboardRepository.getCoursesStatistics(params);

    if (data) {
      dispatch({
        type: 'COURSES_STATISTICS',
        payload: data
      });
    }
  } catch (err) {
    console.log('error', err.message);
  }
};
//----------------------------------------------
// Action that makes the API call to retrieve
// list of best articles sold
export const getArticlesTop = (params = {}) => async (dispatch) => {

  try {
    let { data } = await DashboardRepository.getArticlesTop(params);

    if (data) {
      dispatch({
        type: 'ARTICLES_STATISTICS',
        payload: data
      });
    }
  } catch (err) {
    console.log('error', err.message);
  }
};

//----------------------------------------------
// Action that makes the API call to retrieve
// avg profit statistics
export const getAvgProfitStatistics = (params = {}) => async (dispatch) => {

  try {
    let { data } = await DashboardRepository.getAvgProfitStatistics(params);

    if (data) {
      dispatch({
        type: 'PROFIT_STATISTICS',
        payload: data
      });
    }
  } catch (err) {
    console.log('error', err.message);
  }
};

//----------------------------------------------
// Action that makes the API call to retrieve
// profit values for the chart
export const getProfitChart = (params = {}) => async (dispatch) => {

  try {
    let { data } = await DashboardRepository.getProfitChart(params);

    if (data) {
      dispatch({
        type: 'PROFIT_CHART',
        payload: data
      });
    }
  } catch (err) {
    console.log('error', err.message);
  }
};


//----------------------------------------------
// Action that makes the API call to retrieve
// profit values for the chart
export const startDashboardDataSync = () => async (dispatch) => {
  try {
    let { data } = await DashboardRepository.startDashboardDataSync();

    // Dispatch optional action so reducers can react if needed
    if (data) {
      dispatch({ type: 'DASHBOARD_SYNC_RESULT', payload: data });
    }

    // Return data so caller can handle UI feedback
    return data;
  } catch (err) {
    return { success: false, message: err.message };
  }
};